import React, { useEffect, useState } from "react";
import { Form, Button, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import "react-phone-number-input/style.css";

import {
  SUPPLIER_STATUS,
  VALIDATION_RULES,
  ERROR_MESSAGES,
  TEXTS,
  SUPPLIER_DETAILS_CONSTANTS,
  DESIGNATION_OPTIONS,
} from "../../constants/Constants";

import {
  setFirstName,
  setLastName,
  setEmailId,
  setUserId,
  setPhoneNumber,
  setUserType,
  setDesignation,
  setCountry,
  setIsErrorContactDetails
} from "../../redux/slices/signupSlice";

import FormInput from "../common/FormInput/FormInput";
import axios from "axios";

const ContactDetails = ({ onAdd, clearData }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [currentCountry, setCurrentCountry] = useState("");
  const [contactErrors, setContactErrors] = useState({});

  const {
    FirstName,
    LastName,
    userId,
    emailId,
    phoneNumber,
    userType,
    designation,
    country,
    existingSupplier,isUser
  } = useSelector((state) => state.signup);

 const ROLE=sessionStorage.getItem("Role")
  useEffect(() => {
    setCurrentCountry(country);
  }, [country]);


  useEffect(() => {
    form.setFieldsValue({
      
          firstName: FirstName,
          lastName: LastName,
          userId:userId,
          emailId: emailId,
          phoneNumber: phoneNumber,
          userType: userType,
          designation: designation,
    });
  }, [FirstName, LastName, emailId, phoneNumber, userType, designation, userId, form]);

  useEffect(() => {
    const hasErrors = Object.keys(contactErrors).length > 0;
    dispatch(setIsErrorContactDetails(hasErrors));
  }, [contactErrors]);

  const validateEmailAsync = async (_, value) => {
    if (!value) return Promise.resolve();
    if (existingSupplier) return Promise.resolve(); 
  
    try {
      const response = await axios.get(`https://techsolutionsservice.ustdev.com/signup/emailCheck/${value}`);
      if (response.data) {
        const errorMessage = response.data;
        setContactErrors(prev => {
          const updated = { ...prev, emailId: errorMessage };
          return updated;
        });
        return Promise.reject(new Error(errorMessage));
      }
      
      setContactErrors(prev => {
        const updated = { ...prev };
        delete updated.emailId;
        return updated;
      });
      return Promise.resolve();
    } catch (error) {
      const errorMessage = error.response?.data || "Error validating email";
      setContactErrors(prev => {
        const updated = { ...prev, emailId: errorMessage };
        return updated;
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
  

  const validateUserIdAsync = async (_, value) => {
    if (!value) return Promise.resolve();
    if (existingSupplier) return Promise.resolve(); 
  
    try {
      const response = await axios.get(`https://techsolutionsservice.ustdev.com/signup/userIdCheck/${value}`);
      if (response.data) {
        const errorMessage = response.data;
        setContactErrors(prev => {
          const updated = { ...prev, userId: errorMessage };
          return updated;
        });
        return Promise.reject(new Error(errorMessage));
      }
      

      setContactErrors(prev => {
        const updated = { ...prev };
        delete updated.userId;
        return updated;
      });
      return Promise.resolve();
    } catch (error) {
      const errorMessage = error.response?.data || "Error validating userId";
      setContactErrors(prev => {
        const updated = { ...prev, userId: errorMessage };
        return updated;
      });
      return Promise.reject(new Error(errorMessage));
    }
  };

  const validatePhoneNumber = async (_, value) => {
    if (!value) return Promise.resolve();
  
    try {
      if (!isValidPhoneNumber(value)) {
        const errorMessage = "Please enter a valid phone number for the selected country";
        setContactErrors(prev => {
          const updated = { ...prev, phoneNumber: errorMessage };
          return updated;
        });
        return Promise.reject(new Error(errorMessage));
      }
      

      setContactErrors(prev => {
        const updated = { ...prev };
        delete updated.phoneNumber;
        return updated;
      });
      return Promise.resolve();
    } catch (error) {
      const errorMessage = "Invalid phone number format";
      setContactErrors(prev => {
        const updated = { ...prev, phoneNumber: errorMessage };
        return updated;
      });
      return Promise.reject(new Error(errorMessage));
    }
  };
  
  const handleFieldError = (fieldName, error) => {
    if (error) {
      setContactErrors(prev => {
        const updated = { ...prev, [fieldName]: error };
        return updated;
      });
    } else {
      setContactErrors(prev => {
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });
    }
  };

  const onFinish = (values) => {

    setContactErrors({});
    dispatch(setIsErrorContactDetails(false));
    
    const contactDetails = values;
    dispatch(setFirstName(contactDetails.firstName));
    dispatch(setLastName(contactDetails.lastName));
    dispatch(setUserId(contactDetails.userId));
    dispatch(setEmailId(contactDetails.emailId));
    dispatch(setPhoneNumber(contactDetails.phoneNumber));
    dispatch(setUserType(contactDetails.userType));
    dispatch(setDesignation(contactDetails.designation));

    message.success("Contact Details added Successfully");
    onAdd(values);
    form.resetFields();
  };

  const onCancel = () => {

    setContactErrors({});
    dispatch(setIsErrorContactDetails(false));
    
    dispatch(setFirstName(""));
    dispatch(setLastName(""));
    dispatch(setUserId(""));
    dispatch(setEmailId(""));
    dispatch(setPhoneNumber(""));
    dispatch(setUserType(undefined));
    dispatch(setDesignation(undefined));
    form.resetFields();
    clearData();
  };

  const handleOnChange = (field, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;


    setContactErrors(prev => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    switch (field) {
      case "firstName":
        dispatch(setFirstName(trimmedValue));
        break;
      case "lastName":
        dispatch(setLastName(trimmedValue));
        break;
      case "userId":
        dispatch(setUserId(trimmedValue));
        break;
      case "email":
        dispatch(setEmailId(trimmedValue));
        break;
      case "phoneNumber":
        dispatch(setPhoneNumber(trimmedValue));
        break;
      case "userType":
        dispatch(setUserType(trimmedValue));
        break;
      case "designation":
        dispatch(setDesignation(trimmedValue));
        break;
      default:
        break;
    }
  };

  return (
    <Form 
      form={form} 
      layout="vertical" 
      onFinish={onFinish}
      onFieldsChange={(changedFields) => {
        changedFields.forEach(field => {
          if (field.errors && field.errors.length > 0) {
            handleFieldError(field.name[0], field.errors[0]);
          } else {
            handleFieldError(field.name[0], null);
          }
        });
      }}
    >
      <div className="space-y-4">
        <FormInput
          name="firstName"
          label={TEXTS.FIRSTNAME}
          rules={[
            VALIDATION_RULES.firstNameRequired,
            VALIDATION_RULES.max100,
            VALIDATION_RULES.onlyLetters,
          ]}
          AutoFocus={true}
          placeholder={TEXTS.FIRSTNAME}
          formFieldType="input"
          value={FirstName}
          onChange={(e) => handleOnChange("firstName", e.target.value)}
        />

        <FormInput
          name="lastName"
          label={TEXTS.LASTNAME}
          rules={[
            VALIDATION_RULES.lastNameRequired,
            VALIDATION_RULES.max100,
            VALIDATION_RULES.onlyLetters,
          ]}
          placeholder={TEXTS.LASTNAME}
          formFieldType="input"
          value={LastName}
          onChange={(e) => handleOnChange("lastName", e.target.value)}
        />

        <FormInput
          name="userId"
          label={TEXTS.USERID}
          rules={[
            VALIDATION_RULES.userIdmax10,
            VALIDATION_RULES.userIdRequired,
            {
              validator: async (_, value) => {
              try {
                 await validateUserIdAsync(_, value?.trim());
                 return Promise.resolve();
                 } catch (error) {
                   return Promise.reject(new Error(error.message));
               }
             }
             },
          ]}
          placeholder={TEXTS.USERID}
          formFieldType="input"
          value={userId}
          disabled={existingSupplier}
          keypress={(e) => {
            const specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]/;
            if (specialChars.test(e.key)) {
              e.preventDefault();
            }}}
          onChange={(e) => handleOnChange("userId", e.target.value)}
        />

        <FormInput
          name="emailId"
          label={TEXTS.EMAILID}
          rules={[
            VALIDATION_RULES.emailRequired,
            VALIDATION_RULES.max100,
            {
             validator: async (_, value) => {
                if (!value) return Promise.resolve();

                const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,20}$/;

                if (!emailRegex.test(value)) {
                  const errorMessage = "Invalid email address.";
                  setContactErrors(prev => {
                    const updated = { ...prev, emailId: errorMessage };
                    return updated;
                  });
                  return Promise.reject(new Error(errorMessage));
                }

             try {
                await validateEmailAsync(_, value.trim());
                return Promise.resolve();
                } catch (error) {
                  return Promise.reject(new Error(error.message));
              }
            }
            },
          ]}
          disabled={existingSupplier}
          placeholder={TEXTS.EMAILID}
          formFieldType="input"
          value={emailId}
          onChange={(e) => handleOnChange("email", e.target.value)}
        />

      <Form.Item
  label={TEXTS.PHONENUMBER}
  name="phoneNumber"
  rules={[
    { required: true, message: "Phone number is required" }, 
    { validator: validatePhoneNumber } 
  ]}
>
  <PhoneInput
    international
    countryCallingCodeEditable={false}
    defaultCountry={currentCountry || ""}
    value={phoneNumber}
    onChange={(value) => handleOnChange("phoneNumber", value)}
    className="w-full px-[4px] py-[5px] rounded-md border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
  />
      </Form.Item>

        <FormInput
          name="userType"
          label={TEXTS.USERTYPE}
          className="form-item-left-align"
          rules={[VALIDATION_RULES.userTypeRequired]}
          placeholder={TEXTS.USERTYPE}
          formFieldType="Select"
          value={userType}
          disabled={isUser || ROLE === "Supplier User"}
          options={[
            {
              key: "Supplier Admin",
              value: "Supplier Admin",
              label: SUPPLIER_DETAILS_CONSTANTS.OPTION_ADMIN,
            },
            ...(ROLE === "Supplier Admin"
         ? [
          // {
          //   key: "Supplier User",
          //   value: "Supplier User",
          //   label: SUPPLIER_DETAILS_CONSTANTS.OPTION_USER,
          // },
        ]
        : []),
          ]}
          onChange={(value) => handleOnChange("userType", value)}
        />

        <FormInput
          name="designation"
          label={TEXTS.DESIGNATION}
          className="form-item-left-align"
          rules={[
            { required: false, message: SUPPLIER_DETAILS_CONSTANTS.DESIGNATION_RULE },
          ]}
          placeholder={TEXTS.ENTER_DESIGNATION}
          formFieldType="Select"
          value={designation}
          options={DESIGNATION_OPTIONS}
          onChange={(value) => handleOnChange("designation", value)}
        />

        <Button 
         type="primary" 
          htmlType="submit" 
          className="w-[20%]" 
        >
          {SUPPLIER_DETAILS_CONSTANTS.BUTTON_ADD}
        </Button>
        <Button className="ml-2 w-[20%]" onClick={onCancel}>
          {SUPPLIER_DETAILS_CONSTANTS.BUTTON_CANCEL}
        </Button>
      </div>
    </Form>
  );
};

export default ContactDetails;
